export const CRISP_WEBSITE_ID = 'c379fe30-8c1f-431e-b49d-de9ac36e0d2b'
